import React from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Button,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import Page from "../components/page";

interface SupportArticle {
  slug: string;
  title: string;
}

interface Props {
  categoryTitle: string;
  categorySlug: string;
  articles: SupportArticle[];
}

const SupportCategoryPage: React.FC<Props> = ({
  categoryTitle,
  categorySlug,
  articles,
}) => {
  const history = useHistory();

  const handleArticleClick = (articleSlug: string) => {
    history.push(`/home/support/${categorySlug}/${articleSlug}`);
  };

  return (
    <Page title={categoryTitle}>
      <Box sx={{ px: 4, pt: 0, pb: 1 }}>
        {/* Back button aligned right */}
        <Box display="flex" justifyContent="flex-end" mb={1} mt={1}>
          <Button
            variant="outlined"
            onClick={() => history.push("/home/support")}
          >
            Back to Support
          </Button>
        </Box>

        {/* Article list */}
        {Array.isArray(articles) && articles.length > 0 ? (
          articles.map((article) => (
            <Box key={article.slug} mb={2}>
              <Card onClick={() => handleArticleClick(article.slug)}>
                <CardActionArea>
                  <CardContent>
                    <Typography variant="subtitle1">{article.title}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Box>
          ))
        ) : (
          <Typography>No articles found in this category.</Typography>
        )}
      </Box>
    </Page>
  );
};

export default SupportCategoryPage;
